import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Card' })({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 24,
        boxSizing: 'border-box',
        borderRadius: 24,
        background: '#fff',
        border: '2px solid transparent',
        padding: 24,
        flex: '1 0 0',
        transition: 'all 0.2s',
        textDecoration: 'none',
        position: 'relative',
        zIndex: 1,
        // Hack to avoid slow render of huge shadow
        '&:before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background: 'transparent',
            boxShadow: '0 0 96px 0 #ffd1c4',
            zIndex: -1,
            transition: 'all 0.2s',
            opacity: 0,
            borderRadius: 'inherit',
            backdropFilter: 'blur(40px)'
        },
        '@media (hover: hover)': {
            '&:hover': {
                borderColor: '#fbc5b2',
                background: 'rgba(255, 255, 255, 0.5)',
                '&:before': {
                    opacity: 1
                }
            }
        }
    },
    heading: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2
    },
    title: {
        color: '#232323',
        fontSize: 20,
        fontWeight: 600,
        lineHeight: '150%',
        letterSpacing: '-0.6px'
    },
    date: {
        color: '#8E8E8E',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.32px'
    },
    content: {
        color: '#232323',
        fontSize: 18,
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.36px',
        '& p': {
            margin: 0
        },
        '& ul': {
            margin: 0,
            paddingLeft: 24
        }
    },
    tags: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 4,
        marginTop: 'auto'
    },
    tag: {
        color: '#232323',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px',
        padding: '4px 12px',
        borderRadius: 96
    },
    _blue: {
        backgroundColor: '#E3F2FF'
    },
    _green: {
        backgroundColor: '#E5F6ED'
    },
    _yellow: {
        backgroundColor: '#FFF4E5'
    },
    _pink: {
        backgroundColor: '#FDE7F0'
    },
    _cyan: {
        backgroundColor: '#E9F8FA'
    }
});
